/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useCallback, useMemo } from 'react'
import { Container, TabLesson, ContentWrapper } from './styles'
import { TrackingSchemaTypes } from '../../../../tracking'
import { useTracking } from 'react-tracking'

import VideoLesson from '../VideoLesson'
import TextLesson from './TextLesson'
import NoContent from './NoContent'

import { useLocation } from 'react-router-dom'
import Footer from '../Footer'
import { useLessonContext } from 'pages/Lesson/context'
import { useLessonParams } from 'pages/Lesson/hooks/use-lesson-params'
import { formatSeconds, TimeFormatType } from 'utils/formatSeconds'
import DocumentLesson from './DocumentLesson'
import { IContentDocumento } from 'pages/Lesson/hooks/use-get-lesson/types'

interface ContentProps {
  preference: 'video' | 'text' | 'questions' | string | string[]
  setObject(any): void
  handleContentNavigate(type: string): void
  handleChangePreference(preference: 'video' | 'text' | 'questions'): void
}

const Content: React.FC<ContentProps> = ({
  setObject,
  handleContentNavigate,
  handleChangePreference,
  preference,
}) => {
  const location = useLocation()
  const params = useLessonParams()
  const [typeContent, setTypeContent] = useState<string>()
  const [typeCategory, setTypeCategory] = useState<string>()

  const { swrMenuContent, swrLesson } = useLessonContext()
  const [timeExcerpt, setTimeExcerpt] = useState<number>()

  const lessonData = swrLesson.data
  const menuData = swrMenuContent.data

  //CASO A PREFERÊNCIA SEJA POR TEXTO E NÃO HOUVER CONTEÚDO DO TIPO TEXTO, DEVEMOS MOSTRAR O TIPO VÍDEO, O CONTRÁRIO TAMBÉM É VERDADEIRO
  const handlePreferenceAgainstTypes = () => {
    if (typeContent === 'Video') {
      return 'video'
    } else if (typeContent === 'Documento') {
      return 'document'
    } else {
      return 'text'
    }
  }

  const course = menuData?.course
  const module = menuData?.module
  const lesson = lessonData
  const chapter = lessonData?.chapter
  const contents = lessonData?.contents

  const { trackEvent } = useTracking()

  useEffect(() => {
    if (
      course?.name &&
      module?.name &&
      lesson?.name &&
      chapter?.name &&
      contents.length &&
      typeContent
    )
      trackEvent({
        event: TrackingSchemaTypes.ContentImpression,
        properties: {
          Carreira: course?.career,
          Instituicao: course?.publicTenderInstitution,
          Curso: course?.name,
          Modulo: module?.subject || module?.name,
          Aula: lesson?.name,
          Capitulo: chapter?.name,
          Objeto: contents.find((c) => c.type === 'excerto')?.name,
          Formato:
            typeContent === 'Excerto' ? 'Texto' : typeContent === 'Video' ? 'Vídeo' : 'Documento',
        },
      })
  }, [course?.name, module?.name, chapter?.name, lesson?.name, typeContent])

  useEffect(() => {
    typeFunction()
  }, [lessonData?.chapter?.types])

  const urlQueryString = useMemo(() => {
    if (!location.search) return ''

    const queryString = new URLSearchParams(location.search)
    return queryString
  }, [location.search])

  const typeFunction = useCallback(() => {
    if (!lessonData.contents || !lessonData.contents.length) return setTypeContent('Excerto')
    if ((lessonData?.chapter?.types || []).every((t) => t === 'documento')) {
      setTypeContent('Documento')
      const first = lessonData?.contents[0] as IContentDocumento
      setTypeCategory(first?.category)
      return
    } else if (!(lessonData?.chapter?.types || []).some((t) => t === 'excerto')) {
      return setTypeContent('Video')
    } else if (!(lessonData?.chapter?.types || []).some((t) => t === 'video')) {
      return setTypeContent('Excerto')
    }

    // Se tiver a query string do tipo "...?video=idVideo", seta tipo do conteúdo como vídeo
    if (urlQueryString) {
      if (urlQueryString.get('video')) return setTypeContent('Video')
    }

    if (location.state && location.state['lessonType']) {
      if (location.state['lessonType'] === 'excerpt') {
        return setTypeContent('Excerto')
      } else {
        return setTypeContent('Video')
      }
    } else {
      if (
        (preference === 'text' && lessonData?.chapter?.types.some((t) => t === 'excerto')) ||
        lessonData?.chapter?.types.every((t) => t === 'excerto')
      ) {
        return setTypeContent('Excerto')
      } else if (
        (preference === 'video' && lessonData?.chapter?.types.some((t) => t === 'video')) ||
        lessonData?.chapter?.types.every((t) => t === 'video')
      ) {
        return setTypeContent('Video')
      }
    }
  }, [lessonData?.chapter?.types])

  useEffect(() => {
    const resultado = menuData.children.filter((item) => {
      if (item.children) {
        const child = item.children.find((childItem) => childItem._id === params.chapterId)
        return !!child
      }
      return false
    })

    if (resultado.length > 0) {
      const child = resultado[0].children.find((childItem) => childItem._id === params.chapterId)
      setTimeExcerpt(child.readingTime)
    }
  }, [params.chapterId])

  return (
    <>
      <Container preference={handlePreferenceAgainstTypes()}>
        <TabLesson preference={handlePreferenceAgainstTypes()}>
          <div className="optionsContent">
            <button
              className="text"
              style={{
                display: (lessonData?.chapter?.types || []).some((t) => t === 'excerto')
                  ? 'block'
                  : 'none',
              }}
              onClick={() => {
                handleChangePreference('text')
                setTypeContent('Excerto')
              }}
            >
              Livro digital
            </button>
            <button
              className="video"
              style={{
                display: (lessonData?.chapter?.types || []).some((t) => t === 'video')
                  ? 'block'
                  : 'none',
              }}
              onClick={() => {
                handleChangePreference('video')
                setTypeContent('Video')
              }}
            >
              Vídeo
            </button>
            {lessonData?.chapter?.categories?.map((category, key) => (
              <button
                key={key}
                className={`documento ${
                  typeContent === 'Documento' && category === typeCategory && 'selected-document'
                }`}
                onClick={() => {
                  setTypeContent('Documento')
                  setTypeCategory(category)
                }}
              >
                {category}
              </button>
            ))}
          </div>
          {typeContent === 'Excerto' && timeExcerpt != 0 ? (
            <div className="timeExcerpt">{formatSeconds(timeExcerpt, TimeFormatType.excerto)}</div>
          ) : null}
        </TabLesson>
        {lessonData.contents.length > 0 ? (
          <ContentWrapper preference={handlePreferenceAgainstTypes()}>
            {typeContent && typeContent === 'Excerto' ? (
              <TextLesson handleContentNavigate={handleContentNavigate} key={params.chapterId} />
            ) : typeContent && typeContent === 'Video' ? (
              <VideoLesson setObject={setObject} key={params.chapterId} />
            ) : (
              <DocumentLesson
                category={typeCategory}
                available={lessonData.available}
                contents={lessonData?.contents?.filter((t) => t.type === 'documento')}
              />
            )}
          </ContentWrapper>
        ) : (
          <NoContent
            lessonName={lessonData?.name || menuData.course?.name}
            available={lessonData.available}
          />
        )}
        <Footer
          swrMenuContent={swrMenuContent}
          swrLesson={swrLesson}
          handleContentNavigate={handleContentNavigate}
          typeContent={typeContent}
        />
      </Container>
    </>
  )
}

export default Content
